import styled from 'styled-components'

const Container = styled.div`
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 15px 2px 15px;
  border-bottom: 2px solid #dedede;
  background-color: #005586;
  p{
    color: #fff;
    font-size: 20px;
}
  }

.footer {
  position: relative;
  background: #f1f1f1;
    padding: 7px 0;
  .enter-btn {
    padding: 0;
    position: absolute;
    right: 10px;
    bottom: 0;
    img {
      max-width: 40px;
      margin: -10px;
      padding: 9px;
  }
    }
  }

/* Button used to open the chat form - fixed at the bottom of the page */
.open-button {
    border: none;
    cursor: pointer;
    position: fixed;
    bottom: 23px;
    right: 28px;
    background: transparent;
    z-index: 1;
}

.unread-icon{
  background: #e31616db;
  color: #fff;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  font-size: 14px;
  text-align: center;
  position: fixed;
  bottom: 63px;
  right: 39px;
  z-index: 1;
}

/* The popup chat - hidden by default */
.chat-popup {
  display: block;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 2px solid #f1f1f1;
  z-index: 9;
  border-radius: 10px;
  overflow: hidden;
  @media (max-width:600px) {
    top: 86px;
    height: calc(100vh - 170px);
    left: 15px;
    right: 15px;
  }
}
.chat-window {
  min-height:150px;
  max-height: 450px;
  overflow: auto;
  padding: 10px;
  @media (max-width:1250px) {
    max-height: 400px;
  }
  @media (max-width:600px) {
    max-height: 100%;
  }
}
.chat-listing-user{
  display:flex;
  flex-direction: row-reverse;
  svg {
    margin: 10px;
  }
}

.chat-listing-admin{
  display:flex;
  svg {
    margin: 10px;
  }
}

.chat-container {
  border: 1px solid #dedede;
  background-color: #69BBE0;
  border-radius: 10px 0px 10px 10px;
  padding: 10px;
  max-width: 220px;
  border: 1px solid #69BBE0;
  font-size: 14px;
  color:#fff;
}

.darker {
  border-color: #ccc;
  background-color: #ddd;
  border-radius: 0px 10px 10px 10px;  
  background-color: #fff;
  color:#000000;
}

.chat-container::after {
  content: "";
  clear: both;
  display: table;
}

.chat-container img {
  float: left;
  max-width: 45px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

.chat-container img.right {
  float: right;
  margin-left: 20px;
  margin-right:0;
}

.time-right {
  float: right;
  color: #aaa;
  font-size: 12px;
}

.time-left {
  float: left;
  color: #999;
  font-size: 12px;
}

/* Add styles to the form container */
.form-container {
  min-width: 350px;
  background-color: white;
  @media (max-width:600px) {
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    min-width: 100%;
  }
}

/* Full-width textarea */
.form-container textarea {
  width: 100%;
  padding: 10px 57px 0px 15px;
  border: none;
  background: #f1f1f1;
  resize: none;
  height: 100%;
}

/* When the textarea gets focus, do something */
.form-container textarea:focus {
  background-color: #ddd;
  outline: none;
}

/* Set a style for the submit/send button */
.form-container .btn {
  border: none;
    cursor: pointer;
    opacity: 0.8;
    top: 0;
}

/* Add a red background color to the cancel button */
.form-container .cancel {
  background-color: transparent;
    width: auto;
    padding: 0;
    margin: 0;
    img {
      width: 16px;
    }
}

/* Add some hover effects to buttons */
.form-container .btn:hover, .open-button:hover {
  opacity: 1;
}

`

export {Container}
